import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar", "sentinel"]

  connect() {
    this.observer = new IntersectionObserver(
      ([entry]) => this.barTarget.classList.toggle("d-none", entry.isIntersecting),
      { root: this.element.closest(".comparator-content"), threshold: 0 }
    )
    this.observer.observe(this.sentinelTarget)
  }

  disconnect() {
    this.observer.disconnect()
  }
}
